import {api} from '@/services/api'
import { logger } from '@myorg/type-lib'
import type { UserInfo } from '@/stores/authStore'

export const webAuth = {
  async checkAuth(): Promise<{ success: boolean; user?: UserInfo }> {
    try {
      // Web 模式：呼叫 bff-client 的 /me 端點檢查 OAuth 登入狀態
      const res = await api().get('/api/client/me')
      if (res.data && res.data.authenticated) {
        const user = res.data

        return { success: true, user }
      }
      return { success: false }
    } catch (err) {
      logger.log("webAuth.checkAuth err", err)
      return { success: false }
    }
  },

  async login() {
    // Web 模式：導向 OAuth 登入端點
    // Redirect controlled by facade
  },

  async logout() {
    // Web 模式：server-side logout handled by BFF
    // Redirect controlled by facade
  }
}
